import * as Dtos from '../../dtos/Tmd.dtos';
import { IFieldState, IRegistrationFormState } from "./index";

export const initialInstitutionContractState: Dtos.InstitutionContract & IRegistrationFormState = {
    id: null,
    institutionId: null,
    institution: null,
    agreementName: null,
    noOfOriginalCTRARequired: null,
    institutionContractSiteTypeId: null,
    institutionContractSiteType: null,
    active: null,
    dateEntered: null,
    dateModified: null,
    enteredBy: null,
    modifiedBy: null,
    saveAndReturn: false,
    institutionConfidentialityDeed: null
}

export interface IInstitutionContractReduxFormState {
    id: IFieldState<number>,
    institutionId: IFieldState<number>,
    institution: IFieldState<Dtos.Institution>,
    agreementName: IFieldState<string>,
    noOfOriginalCTRARequired: IFieldState<number>,
    institutionContractSiteTypeId: IFieldState<number>,
    institutionContractSiteType: IFieldState<Dtos.InstitutionContractSiteType>,
    active: IFieldState<boolean>,
    dateEntered: IFieldState<string>,
    dateModified: IFieldState<string>,
    enteredBy: IFieldState<string>,
    modifiedBy: IFieldState<string>,
    institutionConfidentialityDeed: IFieldState<Dtos.InstitutionConfidentialityDeed>
}
